// Breakfast/lunch rotations cover the week with a small number of unique
// recipes. The default curve mirrors the backend's defaultRotationSize
// (mealPlanningService.ts); keep the two in sync.
export const defaultRotationSize = (
  mealType: 'breakfast' | 'lunch',
  dayCount: number
): number => {
  if (mealType === 'breakfast') {
    return dayCount >= 6 ? 3 : dayCount >= 3 ? 2 : 1;
  }
  return dayCount >= 5 ? 2 : 1;
};

// The rotation size cap exposed in the UI. Generation accepts more, but a
// larger rotation against the thin filtered breakfast/lunch pools drops
// catalog coverage and falls back to generating recipes, and it dilutes the
// "simple and repeatable" positioning of these slots.
export const MAX_ROTATION_SIZE = 3;

/**
 * The rotation size a plan will actually use: the explicit override when set,
 * else the plan-length default, clamped to the plan's day count (generation
 * applies the same clamp).
 */
export const effectiveRotationSize = (
  mealType: 'breakfast' | 'lunch',
  dayCount: number,
  override?: number
): number =>
  Math.max(
    1,
    Math.min(
      override ?? defaultRotationSize(mealType, dayCount),
      Math.max(dayCount, 1)
    )
  );
